//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CityList from '@/components/common/CityList'
import FacultyMixin from '@/mixins/faculty.js'
import eventBus from '@/utils/eventBus'
import { mapState } from 'vuex'
import { LOCALE_CODE_RUSSIAN } from '@/const/locale'

export default {
  name: 'FacultyHeader',
  components: { CityList },
  mixins: [FacultyMixin],
  props: {
    isMath: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      isMobileMenuActive: false,
      isTablet: null,
      ws_url: this.$getTextMainSetting('ws_url'),
      tg_url: this.$getTextMainSetting('tg_url'),
    }
  },
  computed: {
    ...mapState(['i18n']),
    isCodingEnabled() {
      return this.isFacultyEnabled('coding') || false
    },
    isMathEnabled() {
      return (
        (this.isFacultyEnabled('math') &&
          this.$getTextMainSetting('branchLanguageCode') ===
            LOCALE_CODE_RUSSIAN) ||
        false
      )
    },
    isBootcampEnabled() {
      return false
    },
  },
  mounted() {
    this.windowSizeHandler()
    window.addEventListener('resize', this.windowSizeHandler, { passive: true })
  },
  methods: {
    getLogo() {
      if (this.isMath) {
        return require('@/assets/img/redesign/math/svg/maths_logo.svg')
      }
      if (this.$i18n.locale === 'ru') {
        return require(`@/assets/img/redesign/coding/svg/programming_logo-ru.svg`)
      }
      return require(`@/assets/img/redesign/coding/svg/programming_logo-en.svg`)
    },
    openMobileMenu() {
      this.isMobileMenuActive = true
    },
    closeMobileMenu() {
      this.isMobileMenuActive = false
    },
    windowSizeHandler() {
      this.isTablet = window.innerWidth <= 960
    },
    onClickPhoneNumber() {
      eventBus.$emit('click-phone-number')
    },
  },
}
